import {
  SAVE_GLOBAL_VOICE_PROMPT_REQUEST,
  SAVE_GLOBAL_VOICE_PROMPT_SUCCESS,
  SAVE_GLOBAL_VOICE_PROMPT_FAILURE,
} from '../actions/globalVoicePromptActions';

const initialState = {
  loading: false,
  error: null,
  data: null,
  lastSavedAt: null,
};

export default function globalVoicePrompt(state = initialState, action) {
  switch (action.type) {
    case SAVE_GLOBAL_VOICE_PROMPT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SAVE_GLOBAL_VOICE_PROMPT_SUCCESS:
      return {
        loading: false,
        error: null,
        data: action.payload,
        lastSavedAt: Date.now(),
      };
    case SAVE_GLOBAL_VOICE_PROMPT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
}

